import React from 'react'
import { GatsbyImage } from "gatsby-plugin-image";

const imageFile = (data, alt, fit) => {

  if(typeof data === 'object') {
    let formattedImage = ""
    
    if(fit === undefined) {
      fit = 'cover';
    }

    if(data.title === undefined) {
      data.title = '';
    }

    if(data.localFile) {
      formattedImage = (
        <GatsbyImage image={data.localFile.childImageSharp.gatsbyImageData} alt={data.title} objectFit={fit}
        />
      )
    }
    return(formattedImage)
  }
  else {
    return ('')
  }

}

export { imageFile }

